import {
  LetterbookOrderOption,
  LetterbookOrderQueryOption,
} from "features/Letterbooks/types";
import { LetterbooksSerializersLetterbooks } from "types/serializers";

// Convert the query params to a sort object
function generateOrderOverride(
  context: LetterbooksSerializersLetterbooks
): LetterbookOrderQueryOption | null {
  const { searchParams } = context;

  if (searchParams.order) {
    return {
      fieldname: searchParams.order,
      direction: searchParams.direction ? searchParams.direction : "asc",
    };
  }

  return null;
}

// Finds the current sort order option from the existing ones
export default function findCurrentOrder(
  context: LetterbooksSerializersLetterbooks,
  sortOptions: LetterbookOrderOption[]
) {
  const override = generateOrderOverride(context);

  if (override) {
    // Find this sort option from the list of options if available
    const newOrder = sortOptions.find(
      (option) => option.fieldname === override.fieldname
    );
    return {
      ...newOrder,
      ...{
        direction: override.direction ? override.direction : newOrder.direction,
      },
    };
  }

  return null;
}
